import { render, staticRenderFns } from "./bukaoChange.vue?vue&type=template&id=091d8348&scoped=true"
import script from "./bukaoChange.vue?vue&type=script&lang=js"
export * from "./bukaoChange.vue?vue&type=script&lang=js"
import style0 from "./bukaoChange.vue?vue&type=style&index=0&id=091d8348&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "091d8348",
  null
  
)

export default component.exports